import { NgModule } from '@angular/core';
import { ZipCodeDirective } from './zipcode-directive';

@NgModule({
  declarations: [ZipCodeDirective],
  exports: [ZipCodeDirective]
})
export class ZipCodeDirectiveModule {}
